import { render, staticRenderFns } from "./shorting-filter.vue?vue&type=template&id=f2ed9018"
import script from "./shorting-filter.vue?vue&type=script&lang=js"
export * from "./shorting-filter.vue?vue&type=script&lang=js"
import style0 from "./shorting-filter.vue?vue&type=style&index=0&id=f2ed9018&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports